var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46Z",
    fill: "url(#paint0_linear_1636_7996)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9977 29.2652L15.2697 24.6997L22.9977 35.5925L30.7326 24.6997L22.9977 29.2652Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.728 23.2346L22.9977 27.8024L15.2674 23.2346L22.9977 10.4075L30.728 23.2346Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.728 23.2346L22.9977 19.7202L22.9977 10.4075L30.728 23.2346Z",
    fill: "#C1CCF7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7326 24.6997L22.9977 35.5925V29.2652L30.7326 24.6997Z",
    fill: "#C1CCF7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9977 19.7202L22.9977 27.8024L15.2697 23.2346L22.9977 19.7202Z",
    fill: "#C1CCF7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.728 23.2346L22.9977 27.8024L22.9977 19.7202L30.728 23.2346Z",
    fill: "#8198EE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1636_7996",
    x1: 23,
    y1: 46,
    x2: 23,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94AEFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinEth);
export default __webpack_public_path__ + "static/media/coin_eth.db27810418fa0629d2c32c010c9e80a1.svg";
export { ForwardRef as ReactComponent };